import { AbstractControl, FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
export class ProductCategory {
    static validation(profile = false): { [key: string]: AbstractControl } {
        let validator: { [key: string]: AbstractControl } = {
            categoryName: new FormControl('', Validators.compose([
                Validators.required,
                ProductCategory.singleSpaceValidator
            ])),
            notes: new FormControl(''),
            categoryMetaFields: new FormArray([new FormGroup(CategoryMetaField.validation())]),
            provinceDiscounts: new FormArray([new FormGroup(ProvinceDiscount.validation())]),
            aiPrompt: new FormControl(''),
        };
        return validator;
    }

    static singleSpaceValidator(control: FormControl) {
        const value = control.value;
        const isValid = /^\S+(\s\S+)*$/.test(value);
        return isValid ? null : { singleSpace: true };
    }

    static provinceFormGroup() {
        return new FormGroup(ProvinceDiscount.validation());
    }

    static readonly validationMessages = {
        'categoryName': [
            { type: 'required', message: 'Obbligatorio' },
            { type: 'singleSpace', message: 'Solo uno spazio è consentito tra le parole' }
        ],
        'categoryMetaFields': {
            'fieldName': [{ type: 'required', message: 'Obbligatorio' }],
            'type': [{ type: 'required', message: 'Obbligatorio' }]
        },
        'provinceDiscounts': {
            'discount': [
                { type: 'pattern', message: 'Deve essere un numero valido' }
            ]
        }
    };

    constructor(
        public id?: number,
        public categoryName?: string,
        public notes?: string,
        public categoryMetaFields?: string,
        public provinceDiscounts?: any,
        public aiPrompt?: string,
    ) { }
}

export class CategoryMetaField {
    public static validation(): { [key: string]: AbstractControl } {
        return {
            fieldName: new FormControl('', Validators.required),
            type: new FormControl('1', Validators.required),
        };
    }

    constructor(
        public fieldName?: string,
        public type?: string
    ) { }
}

export class ProvinceDiscount {
    public static validation(): { [key: string]: AbstractControl } {
        let validator: { [key: string]: AbstractControl } = {
            province: new FormGroup({
                id: new FormControl(null)
            }),
            discount: new FormControl('', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
        };
        return validator;
    }

    constructor(
        public id?: number,
        public provinceCode?: string,
        public province?: any,
        public discount?: any,
        public updatedAt?: Date,
        public createdAt?: Date,
    ) { }
}